import { Grid } from "@mui/material";
import JsonInput from "atoms/JsonInput";
import { useTranslate } from "react-admin";

export default function StorefrontFields() {
  const translate = useTranslate();
  return (
    <Grid item xs={12}>
      <JsonInput
        source="storefront_config"
        label={translate("settings.storefront_config.name")}
        helperText={translate("settings.storefront_config.description")}
        minRows={14}
      />
    </Grid>
  );
}
